import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FencePreviewComponent } from './preview.component';
import { FencePreviewShapeComponent } from './fence-preview-shape/fence-preview-shape.component';
import { TranslateModule } from '@ngx-translate/core';
import { LoaderComponent } from '../../../../ui/loader/loader.component';
import { FencePreviewFenceComponent } from './fence-preview-fence/fence-preview-fence.component';
import { FencePreviewResumeComponent } from './fence-preview-resume/fence-preview-resume.component';
import { FencePreviewElementComponent } from './fence-preview-element/preview-element.component';
import { FencePreviewResumeGroupsComponent } from './fence-preview-resume/preview-resume-groups/preview-resume-groups.component';
import { FencePreviewEnvironmentComponent } from './fence-preview-environment/fence-preview-environment.component';

@NgModule({
  declarations: [
    FencePreviewComponent,
    FencePreviewEnvironmentComponent,
    FencePreviewShapeComponent,
    FencePreviewFenceComponent,
    FencePreviewResumeComponent,
    FencePreviewElementComponent,
    FencePreviewResumeGroupsComponent,
  ],
  imports: [CommonModule, TranslateModule, LoaderComponent],
  exports: [FencePreviewComponent],
})
export class FencePreviewModule {}
